export const usePriceService = () => {

  const getLoggedPrices = (priceLogQueryParams) => {
    return fetch(`/surface/1/products/price_log_prices?${priceLogQueryParams}`);
  }

  return {
    getLoggedPrices
  }
}